import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { ArrowRight } from 'lucide-react'
import { Link as RouterLink } from 'react-router-dom'
import { Button } from '@oasisprotocol/ui-library/src/components/ui/button'
import { useGetRuntimeStatus } from '../../../oasis-nexus/api'
import { useRuntimeFreshness } from '../../components/OfflineBanner/hook'
import { EcosystemCard } from './EcosystemCard'
import sapphireBg from './images/sapphire-bg.svg'
import { fixedNetwork, RouteUtils } from '../../utils/route-utils'
import { Network } from '../../../types/network'

const network: Network = fixedNetwork ?? 'mainnet'

export const OxnCard: FC = () => {
  const { t } = useTranslation()
  const oxnStatusQuery = useGetRuntimeStatus(network, 'sapphire')
  const { outOfDate: oxnOutOfDate } = useRuntimeFreshness({
    network,
    layer: 'sapphire',
  })

  return (
    <EcosystemCard
      isLoading={oxnStatusQuery.isLoading}
      description={t('home.ecosystem.sapphire')}
      title={t('common.sapphire')}
      background={sapphireBg}
      layer="sapphire"
      network={network}
      outOfDate={oxnOutOfDate}
      latestBlock={oxnStatusQuery?.data?.data?.latest_block}
      activeNodes={oxnStatusQuery?.data?.data?.active_nodes}
      footer={
        <div className="flex w-full gap-4">
          <Button size="lg" className="flex-1" asChild>
            <RouterLink to={RouteUtils.getDashboardRoute({ network, layer: 'sapphire' })}>
              {t('common.mainnet')}
              <ArrowRight />
            </RouterLink>
          </Button>
        </div>
      }
    />
  )
}

export const OxnFallbackCard: FC = () => {
  const { t } = useTranslation()

  return (
    <EcosystemCard
      description={t('home.ecosystem.sapphire')}
      title={t('common.sapphire')}
      background={sapphireBg}
      layer="sapphire"
      network={network}
    />
  )
}
